<template>
    <article class="flex flex-col h-full text-center">
        <ProductTileImage :index="index"
                          :content-block-index="contentBlockIndex"
                          :product="product"/>

        <div class="mb-6 font-fauli text-16">
            <RouterLink :to="productUrl"
                        class="hover:text-pink-100">
                {{ productTitle }}
            </RouterLink>
        </div>
        <div class="mt-auto -ml-2 font-numbers text-52 leading-none">
            <Price :amount="product.unitPrice"
                   show-formatted-amount/>
        </div>
        <div class="-mt-3 mb-7 h-17 text-13">
            <span v-if="product.pricePerUnit">{{ product.pricePerUnit }}</span>
        </div>
        <ProductTileCTA :index="index"
                        :content-block-index="contentBlockIndex"
                        :product="product"/>
    </article>
</template>


<script lang="ts">
import { CatalogProductTileViewObject } from '@/api/content/models';
import useTheme from '@/core/theme/useTheme';
import { setPDPBackgroundColor } from '@/project/pages/product-details/product-details-page-color';
import { computed, defineComponent, PropType } from 'vue';
import Price from '../basket/Price.vue';
import ProductTileCTA from './ProductTileCTA.vue';
import ProductTileImage from './ProductTileImage.vue';
import { productService } from './product.service';

type ProductTileTitleSource = CatalogProductTileViewObject & {
    fullname?: string | null;
    fullName?: string | null;
    name?: string | null;
    DisplayName?: string | null;
};

function getProductTitle(product: ProductTileTitleSource): string {
    return product.displayName || product.fullname || product.fullName || product.name || product.DisplayName || '';
}

export default defineComponent({
    name: 'ProductTile',
    components: {
        Price,
        ProductTileImage,
        ProductTileCTA,
    },
    props: {
        product: {
            type: Object as PropType<CatalogProductTileViewObject>,
            required: true,
        },
        stockResults: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        contentBlockIndex: {
            type: Number,
            required: true,
        },
    },
    setup(props) {
        const { themeBackgroundColor } = useTheme();
        setPDPBackgroundColor(themeBackgroundColor.value || '');
        const productTitle = computed(() => getProductTitle(props.product as ProductTileTitleSource));
        const productUrl = productService.getProductRedirectUrlByProduct(props.product);

        return {
            themeBackgroundColor,
            productTitle,
            productUrl,
        };
    },
});
</script>
